/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ListWithdrawalsOptions,
  ListWithdrawalsStatus200,
  ListWithdrawalsStatus400,
  ListWithdrawalsStatus401,
  ListWithdrawalsStatus403,
  ListWithdrawalsStatus500,
} from '../types/ListWithdrawals'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listWithdrawals } from '../clients/listWithdrawals'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listWithdrawalsQueryKey = ({ query }: Omit<ListWithdrawalsOptions, 'headers'> = {}) =>
  [{ url: '/v1/web3/withdrawals' }, ...(query ? [query] : [])] as const

type ListWithdrawalsQueryKey = ReturnType<typeof listWithdrawalsQueryKey>

export function listWithdrawalsQueryOptions(
  { query }: ListWithdrawalsOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = listWithdrawalsQueryKey({ query })
  return queryOptions<
    ListWithdrawalsStatus200,
    ResponseErrorConfig<
      | ListWithdrawalsStatus400
      | ListWithdrawalsStatus401
      | ListWithdrawalsStatus403
      | ListWithdrawalsStatus500
    >,
    ListWithdrawalsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listWithdrawals({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Lists USDC withdrawals ordered by created_at descending. Non-admin callers are always scoped to their own withdrawals. Admin callers get every user's withdrawals by default, and may narrow to one user with `user_id`. This is also the admin review surface for the withdrawal approval flow: filter with `?status=PENDING` to see the withdrawals awaiting review.
 * @summary List USDC withdrawals
 * {@link /v1/web3/withdrawals}
 */
export function useListWithdrawals<
  TData = ListWithdrawalsStatus200,
  TQueryData = ListWithdrawalsStatus200,
  TQueryKey extends QueryKey = ListWithdrawalsQueryKey,
>(
  {
    query,
  }: { query?: ListWithdrawalsOptions['query'] | (() => ListWithdrawalsOptions['query']) } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListWithdrawalsStatus200,
        ResponseErrorConfig<
          | ListWithdrawalsStatus400
          | ListWithdrawalsStatus401
          | ListWithdrawalsStatus403
          | ListWithdrawalsStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? listWithdrawalsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...listWithdrawalsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | ListWithdrawalsStatus400
      | ListWithdrawalsStatus401
      | ListWithdrawalsStatus403
      | ListWithdrawalsStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
